import React, {Component} from 'react';
import { withRouter } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import { getAllBlogsAction } from '../../actions/home';
import ReactHtmlParser from 'react-html-parser';
import './blog.css'

class Blog extends Component {
    constructor(props){
      super(props);      
      this.state = {
          header: "",   
		     items:[],                 
		     viewLoadCount:8,                 
      }; 
      this.loadMore = this.loadMore.bind(this);    
      this.readMore = this.readMore.bind(this);    
    }

    componentWillMount() {
    	this.props.getAllBlogsAction()
    }
    componentWillReceiveProps(nextProps) {
    	if(nextProps.blogData && nextProps.blogData.length > 0){
    		this.setState({
    			items:nextProps.blogData
    		})
    	}
    }

     readMore (index,item){
     	this.props.history.push({
            pathname:"/blog-view/"+item.title.replaceAll(' ', '-'),
            state:{"BlogDetails":item},
        });
     }

     loadMore() {
	  	const {viewLoadCount} = this.state;
	  	this.setState({
	  		viewLoadCount :viewLoadCount+4
	 	})
	 }
    render() {
    	const {viewLoadCount, items} = this.state;
    return (
    <div className="outer-wrapper">
      <Header/>
        <div>
          <div className="container" >
            <div className="row">
              <div className="col-md-12">
                <h1 className="main-heading mt-3">Blog</h1>
                <div className="page-content">
	                <div className="blog_page row">

					{/* {items.slice(0, viewLoadCount).map((item, index) => { */}
					{items.map((item, index) => {
						return (
						<div className="col-lg-6 col-xl-4" key={index}>
		                    <div className="blog_wrap">
			                   { /*<div className="date_wrap">
	                                <span className="blog_date">20</span>
	                                <span className="blog_Month">Aug</span>
			                    </div>*/}
								        
			                    {/* <div className="Blog_img"><img src={process.env.REACT_APP_SERVER_IMAGE_BUCKET +"/"+item.image} className="Blog_img" alt="blogImage"/></div> */}
			                    <div className="Blog_meta">
			                    <h2  href="#" className="Blog_ttl">{item.title}</h2>
			                    <div className="Blog_short_des">{ReactHtmlParser(item.description.slice(0, 200)+ '...')}</div>
		                        <div className="blog_read_more" onClick={()=>this.readMore(index,item)}>
                                    <button  className="btn">Read More</button>
		                        </div>
		                        </div>
		                        <div className="blog_footer"></div>
		                    </div>
	                    </div>
						);
					})}

	                </div>

	                	{/* <button onClick={this.loadMore} type="button" className="load-more btn" disabled={viewLoadCount < items.length ?false:true}>Load more</button> */}
					
                </div>
              </div>
            </div>
            </div>
            <Footer/>
          </div>
        </div>
        )
  }
} 

function mapStateToProps(state) {
	//console.log("state.home",state.home)
  return {
   	blogData : state.home.blogResponse
  }
}

export default withLocalize(withRouter(connect(mapStateToProps, {
	getAllBlogsAction
} )(Blog)));



// WEBPACK FOOTER //
// ./src/components/Blog/Blog.js